import React from "react"
import { concatStrings, formatDateRange } from "../../utilities"
import { t } from "../../../i18n-utility"
import DfbCardIcons from "./dfb_card_icons"
import DfbHeadline from "../../ui-kit/dfb_headline"
import DfbAnchor from "../../ui-kit/dfb_anchor"
import PageContext from "../../page-context"
import DfbSymbol from "../../ui-kit/dfb_symbol"
import DfbImage from "../../ui-kit/dfb_image"
import CCardAuthor from "../c_card_author"
import { Transformation } from "cloudinary-react"
import { isPageAccessRestricted } from "../../../helper/pageAccess.mjs"
import { withPrefix } from "gatsby"

const DfbEventCard = (props) => {
  const external_target =
    props.data.full_slug.indexOf("http://") !== -1 ||
    props.data.full_slug.indexOf("https://") !== -1
      ? { target: "_blank" }
      : {}
  const addClassLink =
    props.variant === "bottom" ? { add_class: "u-Theme-dark" } : {}
  return (
    <a
      className={concatStrings(
        "dfb-Card",
        props.data.add_class,
        props.variant === "bottom" ? "dfb-Card--reverse" : ""
      )}
      href={withPrefix(props.data.full_slug)}
      {...external_target}
    >
      <DfbCardIcons data={props.data} />
      {!props.data.hide_image && props.data.eventdata && (
        <div className="dfb-Card-imageContainer">
          <DfbImage
            image={
              typeof props.data.content.titleimage === "string" &&
              props.data.content.titleimage !== ""
                ? { src: props.data.content.titleimage }
                : props.data.content.titleimage
            }
            add_class="dfb-Card-image"
            lazyload={props.force_image_loading ? false : true}
            aspect_ratio={
              props.data.image_aspect_ratio
                ? props.data.image_aspect_ratio
                : "16:9"
            }
            overlay="55"
          >
            <Transformation
              crop="fill"
              gravity="faces:center"
              width="800"
              height="450"
              quality="auto"
              fetchFormat="auto"
            />
          </DfbImage>
          <div
            className="dfb-Card-eventDate"
            dangerouslySetInnerHTML={{
              __html: formatDateRange({
                startdate: props.data.eventdata.start,
                enddate: props.data.eventdata.end,
                format: "DD.MM.YYYY",
              }),
            }}
          />
        </div>
      )}

      <div className="dfb-Card-content">
        <PageContext.Consumer>
          {({ translations }) => (
            <div className="dfb-Card-topline">
              {props.data.content.card_format_override &&
              props.data.content.card_format_override !== ""
                ? props.data.content.card_format_override
                : t(translations, `cards.${props.data.type}`)}
            </div>
          )}
        </PageContext.Consumer>
        <DfbHeadline
          headline={props.data.title || props.data.name}
          noLevelClass="true"
          headline_level="h4"
          add_class="dfb-Card-headline"
        />

        {props.data.hide_image && (
          <div
            className="dfb-Card-meta"
            dangerouslySetInnerHTML={{
              __html: formatDateRange({
                startdate: props.data.eventdata.start,
                enddate: props.data.eventdata.end,
                format: "DD.MM.YYYY",
                withoutMarkup: true,
              }),
            }}
          />
        )}

        {props.data.content.author &&
          props.data.content.author.show_on_card === 1 && (
            <CCardAuthor
              author={props.data.content.author}
              force_image_loading={props.force_image_loading}
            />
          )}

        {props.data.content.card_callout &&
          props.data.content.card_callout !== "" && (
            <div className="dfb-Card-disturber">
              <div className="dfb-Icon dfb-Card-disturberIcon">
                <DfbSymbol icon_type="Information" />
              </div>
              <p className="dfb-Card-disturberContent">
                {props.data.content.card_callout}
              </p>
            </div>
          )}
      </div>
      <div className="dfb-Card-footer">
        <PageContext.Consumer>
          {({ translations }) => (
            <DfbAnchor
              tagName="div"
              {...addClassLink}
              secondary={true}
              text={t(translations, "dfb_anchor.morelink")}
              locked={isPageAccessRestricted(props.data)}
            />
          )}
        </PageContext.Consumer>
      </div>
    </a>
  )
}

export default DfbEventCard
